import type { AxiosInstance } from "axios";

import {
	type BooleanResult,
	ErrorResponseFactory,
	Result,
} from "@services/sdk/models";

import { Actioner } from "@services/actioner";

export const createMRTMAuthAdapter = (httpClient: AxiosInstance) => {
	return {
		async verifyEmail(email: string): Promise<BooleanResult> {
			try {
				await httpClient.post("/auth/validate", {
					username: email,
				});

				return Result.Success(true);
			} catch (err: any) {
				Actioner.trigger(Actioner.keyDefs.ERROR, err);
				return Result.Failure(ErrorResponseFactory.ErrorVerifyEmail(err));
			}
		},
	};
};
